import { GymExercises } from "@/components/gym-exercises";
import { createFileRoute } from "@tanstack/react-router";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(protected)/exercises/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <div className="flex h-full flex-col">
        <MobilePageTitle className="mx-6 mt-5">
          {t("pages:dashboard.sidebar.exercises")}
        </MobilePageTitle>
        <GymExercises />
      </div>
    </ScrollableContainer>
  );
}
